
<template>
  <transition name="fade" @enter="enter" appear="">
    <div v-if="this.scenes.ending">
      <div class="scene-wrap">
        <video class="enter-video" id="ending-video" muted playsinline preload>
          <source src="/media/ending_1_4.mp4" type="video/mp4" />
        </video>
        <div class="ending-wrap">
          <!-- <h1>Ending...</h1>
        {{ this.visitedScene }} -->
          <div class="quote-wrap">
            <div class="quote hide" data="0">
              <span v-html="this.ending[lang][0]"></span>
            </div>
            <div class="quote hide" data="1">
              <span v-html="this.ending[lang][1]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import anime from "animejs";

import endingData from "./../assets/data/ending.json";
import gameController from "./../gameController";

export default {
  name: "Ending",
  props: ["scenes", "visitedScene", "isTest", "isDebug", "lang"],
  data() {
    return {
      ending: endingData,
    };
  },
  mounted() {
    this.emitter.on("hide-loading", () => {
      if (this.scenes.ending && $("#ending-video")[0]) {
        $("video")[0].play();
        console.log("[Ending] play video");
      }
    });
  },
  created() {
    //start preload
  },
  methods: {
    enter() {
      var eventLabel =
        gameController.ConvertScene(this.visitedScene[0]) +
        ", " +
        gameController.ConvertScene(this.visitedScene[1]);
      console.log("[Event] label: " + eventLabel);
      this.$gtag.event("enter", {
        event_category: "ending",
        event_label: eventLabel,
      });

      var event = "Ending: " + eventLabel;
      this.$gtag.event(event, {
        event_category: "ending",
        event_label: eventLabel,
      });

      if (!$(".quote").hasClass("hide")) {
        $(".quote").addClass("hide");
      }

      var vid = document.getElementById("ending-video");
      // var delay = 7000;

      if (this.isTest || this.isDebug) {
        if (vid) {
          vid.playbackRate = 15;
          vid.play();
          $("video")[0].play();
        }
        // delay = 90000;
      }

      vid.addEventListener("suspend", () => {
        if (vid.paused) {
          $(".enter-video").attr("controls", true);
        }
      });

      vid.addEventListener("play", () => {
        $(".enter-video").attr("controls", false);
      });

      var quoteShown = false;
      var end_tl = anime.timeline({
        autoplay: false,
      });

      end_tl
        .add({
          duration: 5000,
          begin: function () {
            console.log("end tl begin");
            $(".quote[data='0']").removeClass("hide");
          },
          complete: function () {
            $(".quote[data='0']").addClass("hide");
          },
        })
        .add({
          duration: 6000,
          begin: function () {
            setTimeout(function () {
              $(".quote[data='1']").removeClass("hide");
            }, 1000);
          },
          complete: function () {
            $(".quote[data='1']").addClass("hide");
            console.log("restart");
            this.emitter.emit("restart");
          }.bind(this),
        });
      $("#ending-video")[0].addEventListener("timeupdate", function myfunc() {
        // console.log("hi:"+$("#ending-video")[0].currentTime)
        if (this.currentTime > this.duration - 2) {
          // console.log("quoteShown: " + quoteShown);
          if (!quoteShown) {
            //Do something here..
            console.log("ending words");
            quoteShown = true;
            end_tl.restart();
          }
        }
      });

      var src;
      if (this.visitedScene[0]) {
        src =
          "/media/ending_" +
          this.visitedScene[0] +
          "_" +
          this.visitedScene[1] +
          ".mp4";
      } else {
        src = "/media/ending_1_4.mp4";
      }

      $("#ending-video source").attr("src", src);
    },
  },
};
</script>

